import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from "react-router-dom";

import { Box, CircularProgress } from '@mui/material';

// Auth lives in an HttpOnly cookie now, so the frontend can't peek at it.
// MainRouter dispatches BootstrapAuth on mount, which sets authStatus to
// "authenticated" or "unauthenticated". While that's in flight we show a
// neutral loading state — gating on this avoids a flash of the login screen.
const ProtectedRoutes = () => {
    const authStatus = useSelector(state => state.auth.authStatus);

    if (authStatus === "unknown") {
        return (
            <Box
                className="flexCenterCenterRow"
                sx={{ height: "100vh", width: "100vw" }}>
                <CircularProgress />
            </Box>
        );
    }

    return authStatus === "authenticated" ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
